import { render, staticRenderFns } from "./sendFoem.vue?vue&type=template&id=07badb30&scoped=true&"
import script from "./sendFoem.vue?vue&type=script&lang=js&"
export * from "./sendFoem.vue?vue&type=script&lang=js&"
import style0 from "./sendFoem.vue?vue&type=style&index=0&id=07badb30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07badb30",
  null
  
)

export default component.exports